import application from 'application/application';

application.filter('highlight', function($sce) {
	return function(text, search) {
		if (!search) {
			return $sce.trustAsHtml(text);
		}
		const normalize = str =>
			str
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.toLowerCase();

		const normalizedSearch = normalize(search);
		// const regex = new RegExp(normalizedSearch, 'gi');

		const getHighlightPositions = text => {
			const positions = [];
			const normalizedText = normalize(text);
			let match;
			const searchRegex = new RegExp(normalizedSearch, 'g');

			while ((match = searchRegex.exec(normalizedText)) !== null) {
				positions.push(match.index);
			}

			return positions;
		};

		const highlightText = (text, positions, searchLength) => {
			let result = '';
			let lastIndex = 0;

			positions.forEach(pos => {
				result += text.substring(lastIndex, pos);
				result += `<span class="highlight">${text.substring(
					pos,
					pos + searchLength
				)}</span>`;
				lastIndex = pos + searchLength;
			});
			result += text.substring(lastIndex);

			return result;
		};

		const highlightPositions = getHighlightPositions(text, search);
		const highlightedText = highlightText(
			text,
			highlightPositions,
			search.length
		);

		return $sce.trustAsHtml(highlightedText);
	};
});
